export default {
    mainMenu: {
        join: 'Start',
        create: 'Start',
        admin: 'Admin',
        language: 'Language'
    },
    login: {
        username: 'Username',
        password: 'Password',
        login: 'Login',
        failed: 'Login failed',
        logout: 'Log Out'
    },
    intro: {
		title: 'How To Play',
		description: 'Bla bla bla<br><br>'
	},
    room: {
        connecting: 'Connecting',
        loading: 'Loading',
        roomCode: 'Room code',
        description: 'Scan the QR-code or follow the link.<br>Then enter the following code:',
		join: 'Join',
		url: 'Url',
        codeError: 'Wrong room code',
        serverError: 'No connection to server',
        connectionError: 'Could not connect',
        lobby: 'Lobby',
        waiting: 'Waiting',
        pageType: 'Game Mode',
        unset: 'Unset',
        dilemma: 'Vote & Discuss',
        count: 'Players entered'
    },
    master: {
        selectTheme: 'Select a theme'
    },
    game: {
        answers: 'Answers',
        chooseAnswer: 'Select an answer',
        showAnswers: 'Results',
        sendMessage: 'Send Message',
        studentWaiting: 'Look at the facilitator\'s screen'
    },
    misc: {
        back: 'Back',
        cancel: 'Cancel',
        quit: 'Quit',
        start: 'Start',
        next: 'Next',
        finish: 'Finish',
        continue: 'Continue',
        select: 'Select',
		fullScreen: 'Full screen'
    }
} 